import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import { NavLink, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import useProjectsCount from "hooks/projects/useProjectsCount";
import useWorkItemsCount from "hooks/work-items/useWorkItemsCount";
import { WorkItemStatus } from "models/work-items/IMyWorkItem";
import { useEffect } from "react";

//#region Interfaces ... 
interface ILinkTabProps {
    text?: string;
    href?: string;
    type?: string;
}
//#endregion

//#region Styles Components ... 
const TaskTabs = styled(Tabs)({
    color: '#333333',
    position: 'relative',
    '& .MuiTabs-indicator': {
        color: '#001A69',
        backgroundColor: '#001A69',
        height: '3px',
        borderRadius: '4px',
    }
});

const TabLinkStyled = styled(NavLink)(({ theme }) => ({
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '10px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#333333',
    textTransform: 'uppercase',
    textDecoration: 'none',

    '&.active': {
        color: theme.palette.secondary.main,
        fontWeight: 600
    }
}));
//#endregion 

const TabLink = (props: ILinkTabProps) => (
    <TabLinkStyled end to={props.href || ""}>{props.text}</TabLinkStyled>
)

const LinkTab = (props: ILinkTabProps) => (
    <Tab
        component={TabLink}
        {...props}
    />
)

const tabs = [
    {
        text: 'In Progress',
        path: '/in-progress'
    },
    {
        text: 'Upcoming',
        path: '/upcoming'
    },
    {
        text: 'On Hold',
        path: '/on-hold'
    },
    {
        text: 'Completed',
        path: '/completed'
    },
    {
        text: 'Cancelled',
        path: '/cancelled'
    },
    {
        text: 'All',
        path: '/all'
    }
];

const TabsHeader = (props: ILinkTabProps) => {
    const location = useLocation();
    const selectedTab = tabs.findIndex(t => location.pathname.includes(t.path));
    
    const isProjects = location.pathname.includes('projects');

    const isAll = location.pathname.includes('projects/all') || location.pathname.includes('workitems/all');
    
    const [projectsTotal, projectsLoading, projectsError, projectsForceRefresh] = 
        useProjectsCount('on-hold', isAll, isProjects);
    
    const [workItemsTotal, workItemsLoading, workItemsError, workItemsForceRefresh] = 
        useWorkItemsCount('on-hold', isAll, !isProjects);

    useEffect(() => {
        workItemsForceRefresh();
        projectsForceRefresh();
    }, [isAll]);

    const total = isProjects ? projectsTotal : workItemsTotal;

    const evalPath = (path: string) => {        
        if (props.type?.endsWith('/all') && path === '/all') {
            return props.type;
        }
        return `${props.type ? props.type : 'tasks/my'}${path}`
    }

    const evalTextLabel = (text: string, statusToEval: string = 'On Hold') => {
        if (text.includes(statusToEval) && total > 0)
            return `${text} (${total})`;
        else
            return text;
    }

    return (
        <Box sx={{ width: '100%', mb: '25px' }}>
            <TaskTabs value={selectedTab} aria-label="tasks tabs">
                {tabs.map((tab, index) => (
                    <LinkTab 
                        key={index}
                        text={evalTextLabel(tab.text)} 
                        href={`/${evalPath(tab.path)}`} 
                    />
                ))}
            </TaskTabs>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: '-2px' }}></Box>
        </Box>
    )
}

export default TabsHeader;